import {EMPTY_TRUCK, RRTruckType} from "../../types/RRTruckType";
import {RRDayType} from "../../types/RRDayType";

export type RRLogisticType = {
    id?: string;
    revision?: number;
    driverId: string;
    driverName: string;
    dayType: RRDayType;
    startDate: Date;
    endDate: Date;
    workInStore: boolean;
    eventNumber: string;
    isOwn: boolean;
    truck: RRTruckType;
    startPoint: string;
    endPoint: string;
    planNotes: string;
    reportStartDate: Date | null;
    startKm: number | null;
    reportEndDate: Date | null;
    endKm: number | null;
    reportNotes: string;
}

export const EMPTY_LOGISTIC: RRLogisticType = {
    driverId: "",
    driverName: "",
    dayType: "WORKDAY",
    startDate: new Date(),
    endDate: new Date(),
    eventNumber: "",
    workInStore: true,
    isOwn: true,
    truck: {...EMPTY_TRUCK},
    startPoint: "",
    endPoint: "",
    planNotes: "",
    reportStartDate: null,
    startKm: null,
    reportEndDate: null,
    endKm: null,
    reportNotes: ""
}
